<template>
  <!--
    Networking section shell. Renders the standard top Navbar (same as
    Event Info / Program / Profile) so the networking pages open as a
    normal tab rather than a separate full-screen sidebar layout. The
    page content is supplied via the default slot and provides its own
    padding / max-width. Section navigation (AI Matches / Meetings /
    Open Sessions) lives in each page's header via <NetworkingQuickNav>.
  -->
  <div
    class="networking-layout"
    style="
      background-color: #ffffff;
      min-height: 100vh;
      font-family: 'Poppins', sans-serif;
    "
  >
    <Navbar :show-nav="true" />
    <main id="main-content" role="main" class="networking-layout__main">
      <slot></slot>
    </main>
  </div>
</template>

<script>
import Navbar from '@/components/shared/Navbar.vue';

export default {
  name: 'ParticipantDashboardLayout',
  components: { Navbar }
};
</script>

<style scoped>
.networking-layout {
  display: flex;
  flex-direction: column;
}
.networking-layout__main {
  flex: 1 1 auto;
  min-width: 0;
  /* Breathing room at the bottom of every networking page (extra on mobile
     so content clears the fixed bottom-nav pill). */
  padding-bottom: 4rem;
}
@media (max-width: 640px) {
  .networking-layout__main {
    padding-bottom: 6rem;
  }
}
</style>
